import { copy as sharedUiCopy } from '@shared/copy';
import { Skeleton, SkeletonHead, SkeletonMetaGrid, SkeletonThread } from '@shared/ui/Skeleton';

/**
 * The pending state of `/cases/:caseId`.
 *
 * The head, then the three sections the surface is made of — the facts, the
 * thread, and the state control. Each opens on its own `CaseSection` heading
 * row, and those rows are drawn rather than skipped: they arrive with the
 * payload, so a placeholder that omitted them would drop three headings into
 * the page under the operator's eye.
 *
 * The state control is a select beside its action from the tablet tier, which
 * is why it is drawn as a field-and-button row rather than as a filled panel of
 * the same height. It is the element this surface exists for, and a grey box
 * where it stands says nothing about that.
 */
function SectionHeadSkeleton() {
  return (
    <div className="mb-4 flex flex-wrap items-center gap-x-3 gap-y-2">
      <Skeleton className="h-7 w-[8rem]" />
    </div>
  );
}

export function CaseDetailSkeleton() {
  return (
    <>
      <p role="status" className="sr-only">
        {sharedUiCopy.state.loading}
      </p>

      <SkeletonHead />

      <section aria-hidden="true" className="mt-section-gap first:mt-0">
        <SectionHeadSkeleton />
        <SkeletonMetaGrid rows={5} />
      </section>

      <section aria-hidden="true" className="mt-section-gap">
        <SectionHeadSkeleton />
        <SkeletonThread messages={3} />
      </section>

      <section aria-hidden="true" className="mt-section-gap">
        <SectionHeadSkeleton />
        <div className="overflow-hidden rounded-md border border-border bg-surface">
          <div className="p-4 md:p-5">
            <div className="grid gap-3 md:flex md:items-end md:gap-4">
              <div className="grid flex-1 gap-2">
                <Skeleton className="h-4 w-[7rem]" />
                <Skeleton className="h-[2.75rem] w-full rounded-sm" />
              </div>
              <Skeleton className="h-[2.75rem] w-full rounded-sm md:w-[8rem]" />
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
